import { apiClient } from '@isocel/front-common';
import { useQuery } from 'react-query';

import { Supplier } from './types';

export const fetchSuppliers = async (): Promise<Supplier[]> => {
    const { data } = await apiClient().get(`/suppliers`);
    return data;
};
export const useSupplierByStore = (store: string, organization?: string) => {
    return useQuery<Supplier[], Error>(['suppliers', store, organization], async () => {
        const data = await fetchSuppliers();

        const storeSuppliers = data.filter((supplier) => supplier.store === store);

        const orgSuppliers = data.filter(
            (supplier) => organization && supplier.organization === organization && supplier.store === null
        );

        const combinedSuppliers = [...storeSuppliers, ...orgSuppliers];

        combinedSuppliers.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

        return combinedSuppliers;
    });
};
